import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { KnBrOrderReturnAdapter } from '../../connectors/kn-br-order-return.adapter';
import {
  KnBrOrderReturnActionTypes,
  KnBrOrderReturnActions,
  KnBrReturnOrdersQuickSearchSuccess,
  KnBrReturnOrdersSearchFailure,
  KnBrReturnOrdersSearchSuccess,
} from '../actions/kn-br-order-return.action';

@Injectable()
export class KnBrOrderReturnEffects {
  // @Effect()
  searchReturnOrders$ = createEffect(() =>
    this.actions$.pipe(
      ofType(KnBrOrderReturnActionTypes.KnBrReturnOrdersSearchAction),
      mergeMap((action) =>
        this.orderReturnAdapter.retrunOrdersSearch(action.payload).pipe(
          map((data: any) => {
            return action.payload?.isWidget
              ? new KnBrReturnOrdersQuickSearchSuccess(data)
              : new KnBrReturnOrdersSearchSuccess(data);
          }),
          catchError((error: Error) => {
            this.messageService.add({ key: 'knBrMessages.error' }, GlobalMessageType.MSG_TYPE_ERROR);
            return of(new KnBrReturnOrdersSearchFailure(error));
          })
        )
      )
    )
  );

  //@Effect({ dispatch: false })
  searchReturnOrdersFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(KnBrOrderReturnActionTypes.KnBrReturnOrdersSearchFailureAction),
        map(() => {
          this.messageService.add({ key: 'knBrMessages.error' }, GlobalMessageType.MSG_TYPE_ERROR);
        })
      ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions<KnBrOrderReturnActions>,
    private orderReturnAdapter: KnBrOrderReturnAdapter,
    private messageService: GlobalMessageService
  ) {}
}
